import React from "react";
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
import globalStyles from "../styles";
import { grey500 } from "material-ui/styles/colors";
import Divider from "material-ui/Divider";
import PageBase from "../components/PageBase";
import { Helmet } from "react-helmet";

const DashboardPage = () => {
  const styles = {
    floatingActionButton: {
      margin: 0,
      top: "auto",
      right: 20,
      bottom: 20,
      left: "auto",
      position: "fixed",
    },
    ordutegiZerrenda: {
      textAlign: "center",
      listStyle: "none",
    },
    editButton: {
      fill: grey500,
    },
    images: {
      width: "100px",
      maxWidth: "100%",
      margin: "20px",
    },
    filas: {
      textAlign: "left",
    },
  };

  return (
    <PageBase
      title="Programazioa"
      navigation="Oñatiko Duatloi Txikia / Programazioa"
    >
      <Helmet>
        <title>Oñatiko Dutloi Txikia</title>
        <meta
          name="description"
          content="Oñatiko Duatloi Txikia, gaztetxoenek duatloi eta triatloien mundua ezagutu dezaten antolatzen da"
        />
        <meta property="og:title" content="Oñatiko Dutloi Txikia" />
        <meta
          property="og:description"
          content="Oñatiko Duatloi Txikia, gaztetxoenek duatloi eta triatloien mundua ezagutu dezaten antolatzen da"
        />
        <meta property="og:url" content="http://txikia.oñatikoduatloia.com" />
        <meta
          property="og:image"
          content="http://txikia.oñatikoduatloia.com/kartela-duatloi-txikia.png"
        />
      </Helmet>
      <center style={{ marginTop: "20px" }}>
        <img
          src={require("../images/2022-marrazki-beltza.png")}
          style={styles.images}
        />
        <img
          src={require("../images/eskudo_aloina.png")}
          style={styles.images}
        />
      </center>

      <center style={{ marginTop: "20px" }}>
        <img
          src={require("../images/logo_eskola_kirola.png")}
          style={styles.images}
        />
        <img src={require("../images/logo-ulma.png")} style={styles.images} />
        <img src={require("../images/logo_lana.jpg")} style={styles.images} />
        <img src={require("../images/oinati.jpg")} style={styles.images} />
      </center>

      <h3 style={globalStyles.navigation}>Programazioa</h3>
      <Table>
        <Thead>
          <Tr>
            <Th style={styles.filas}>Noiz</Th>
            <Th style={styles.filas}>Zer/Non</Th>
          </Tr>
        </Thead>
        <Tbody>
          <Tr>
            <Td>Martxoaren 18a, larunbata</Td>
            <Td>Oñatiko Plazan</Td>
          </Tr>
          <Tr>
            <Td>Izenemateak</Td>
            <Td>Eskola kirolak kudeatuta, Martxoaren 15a 23:59 baino lehen</Td>
          </Tr>
          <Tr>
            <Td>10:00 - 10:45</Td>
            <Td>Dortsalen banaketa gaztelekuan</Td>
          </Tr>
          <Tr>
            <Td>10:15 - 10:50</Td>
            <Td>Boxetara sarrera bizikleta uzteko</Td>
          </Tr>
        </Tbody>
      </Table>

      <h3 style={globalStyles.navigation}>Ordutegiak</h3>
      <Divider />

      <Table>
        <Thead>
          <Tr>
            <Th style={styles.filas}>Ordua</Th>
            <Th style={styles.filas}>Kategoria</Th>
            <Th style={styles.filas}>Korrika 1</Th>
            <Th style={styles.filas}>Bizikleta</Th>
            <Th style={styles.filas}>Korrika 2</Th>
          </Tr>
        </Thead>
        <Tbody>
          <Tr>
            <Td>11:00</Td>
            <Td>Benjaminak</Td>
            <Td>500m</Td>
            <Td>1500m</Td>
            <Td>500m</Td>
          </Tr>

          <Tr>
            <Td>11:20</Td>
            <Td>Alebinak</Td>
            <Td>1000m</Td>
            <Td>3500m</Td>
            <Td>500m</Td>
          </Tr>
          {/*
                    <Tr>
                      <Td>11:30</Td>
                      <Td>Infantilak eta Kadeteak</Td>
                      <Td>2000m</Td>
                      <Td>7000m</Td>
                      <Td>1000m</Td>
                    </Tr>
                */}
        </Tbody>
      </Table>

      {/*

           <h3 style={globalStyles.navigation}>Izenemateak</h3>
      
            <div className="row">
              <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4 m-b-15 ">
                <InfoBox Icon={Face}
                         color={pink600}
                         title="Benjaminak"
                         value="0"
                />
              </div>


              <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4 m-b-15 ">
                <InfoBox Icon={Face}
                         color={cyan600}
                         title="Alebinak"
                         value="0"
                />
              </div>

              <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4 m-b-15 ">
                <InfoBox Icon={Face}
                         color={purple600}
                         title="Infantilak"
                         value="0"
                />
              </div>
            </div>
        */}
    </PageBase>
  );
};

export default DashboardPage;



/** WEBPACK FOOTER **
 ** ./src/containers/DashboardPage.js
 **/